import { createBuiltInThemeManager } from "@sieg-ad/componentes-vue";
import { defineStore } from "pinia";

export type ThemeOptions = 'light' | 'dark';

//? Só o manager do pacote injeta o CSS do tema; `setAttribute('data-theme')` na mão troca o
//? atributo, mas os tokens do escuro nunca chegam ao documento.
const manager = createBuiltInThemeManager('light');

export const useThemeStore = defineStore('theme', {
  state: (): { current: ThemeOptions } => ({
    current: 'light',
  }),
  persist: {
    storage: localStorage,
    pick: ['current'],
  },
  getters: {
    escuro: (state) => state.current === 'dark',
  },
  actions: {
    async init(): Promise<void> {
      await manager.setTheme(this.current);
    },
    async toggle(): Promise<void> {
      await this.setTheme(this.escuro ? 'light' : 'dark');
    },
    async setTheme(theme: ThemeOptions): Promise<void> {
      this.current = theme;

      //? Sem isto cada componente com `transition` (o s-card tem `all`) desbota no seu ritmo e a
      //? tela troca de tema aos pedaços. `.no-transition` vem do componentes-vue.
      document.body.classList.add('no-transition');
      try {
        await manager.setTheme(theme);
      }
      finally {
        setTimeout(() => document.body.classList.remove('no-transition'), 300);
      }
    },
  },
})
